import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../../contexts/AuthContext';
import { authHeaders } from '../../utils/useLog';
import { TermsCheckbox } from './TermsCheckbox';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/terms`;
const OPEN_PATHS = ['/', '/terms', '/terms-of-service', '/saas-agreement', '/privacy-policy', '/login', '/book-demo', '/demo/manage'];

export default function TermsGate() {
  const { isAuthenticated, user, logout } = useAuth();
  const { pathname } = useLocation();
  const [status, setStatus] = useState(null);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) { setStatus(null); return; }
    fetch(`${API}/status`, { credentials: 'include', headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : null)).then(setStatus).catch(() => setStatus(null));
  }, [isAuthenticated, user?.id]);

  if (!status?.required || OPEN_PATHS.includes(pathname)) return null;

  const accept = async () => {
    setBusy(true);
    const r = await fetch(`${API}/accept`, {
      method: 'POST', credentials: 'include',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ accepted: true, version: status.version }),
    });
    setBusy(false);
    if (!r.ok) { toast.error((await r.json()).detail || 'Could not record acceptance'); return; }
    toast.success('Thank you - your acceptance has been recorded');
    setStatus({ ...status, required: false });
  };

  return (
    <div className="fixed inset-0 z-[1000] bg-black/60 flex items-center justify-center p-4" data-testid="terms-gate-modal">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6 text-left">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Updated Terms</h2>
        <p className="text-sm text-gray-600 mb-4">
          We have updated the LightStream Terms of Service and SaaS Agreement (last updated {status.updated}). They now cover every Genius module and
          protect LightStream's proprietary technology. Please review and accept them to continue.
        </p>
        <TermsCheckbox checked={checked} onChange={setChecked} testid="terms-gate-checkbox" />
        <div className="flex gap-3 mt-6">
          <button onClick={accept} disabled={!checked || busy} className="flex-1 bg-blue-600 text-white rounded-lg px-4 py-2 font-medium hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed" data-testid="terms-gate-accept-btn">
            {busy ? 'Saving...' : 'Accept and continue'}
          </button>
          <button onClick={logout} className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100" data-testid="terms-gate-signout-btn">
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
